module.exports = __webpack_public_path__ + "assets/TMoveDetailed.94bbebe7397f1ea7925c9b45b8e20dcd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/1x/TMoveDetailed.png
// module id = 580
// module chunks = 0